import React, { FC } from 'react';
import styled from 'styled-components';
import Typography from '../Typography';

type SpacingPreset = 'compact' | 'normal' | 'none';

interface ContentBlockProps {
  px?: SpacingPreset;
  gap?: SpacingPreset;
}

export const ContentBlock = styled.div<ContentBlockProps>`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  margin-left: ${({ px = 'normal' }) => {
    if (px === 'normal') return '24px';
    if (px === 'compact') return '16px';
    return '0';
  }};
  margin-right: ${({ px = 'normal' }) => {
    if (px === 'normal') return '24px';
    if (px === 'compact') return '16px';
    return '0';
  }};

  gap: ${({ gap = 'normal' }) => {
    if (gap === 'normal') return '16px';
    if (gap === 'compact') return '8px';
    return '0';
  }};
`;

interface ContentSectionProps {
  title?: string;
  px?: SpacingPreset;
  gap?: SpacingPreset;
  children?: React.ReactNode;
  id?: string;
}

export const ContentSection: FC<ContentSectionProps> = ({
  title,
  px = 'normal',
  gap = 'normal',
  children,
  id,
}) => {
  return (
    <ContentBlock px={px} gap={gap} id={id}>
      {title && (
        <Typography variant="titleMedium" color="var(--sys-color--on-surface-variant)">
          {title}
        </Typography>
      )}
      {children}
    </ContentBlock>
  );
};
